<template>
  <div>
    <b-form-group
      horizontal
      :label="label"
      label-class="font-weight-semibold text-gray-700"
      v-if="state == 'creating' || state == 'updating'"
    >
      <b-input-group>
        <b-input-group-prepend>
          <b-form-select
            @change="prefixChanged"
            v-model="prefix"
            :options="prefixes"
          ></b-form-select>
        </b-input-group-prepend>
        <b-form-input v-model="numericCode"></b-form-input>
      </b-input-group>
    </b-form-group>
    <div v-else>
      <span class="text-gray-700">{{ label }} </span>
      <div class="d-flex align-items-center text-gray-700">
        <svg class="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 20l4-16m2 16l4-16M6 9h14M4 15h14">
          </path>
        </svg>
        <span class="font-weight-semibold">{{ value }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      prefix: "A",
      numericCode: null,
      prefixes: [],
    };
  },
  computed: mapState({
    state: (state) => state.employeeManager.state,
  }),
  mounted() {
    if (this.state == "creating") {
      this.getNextCode(this.prefix).then((numeric) => {
        this.numericCode = numeric;
      });
    }

    if (this.value) {
      let pattern = /^([A-Z]+)([0-9]+)$/;
      let match = this.value.match(pattern);
      if (match !== null) {
        this.prefix = match[1];
        this.numericCode = match[2];
        this;
      }
    }

    this.prefixes = prefixes;
  },
  created() {
    this.$store.watch(
      (state) => state.employeeManager.state,
      (newState) => {
        if (newState == "creating") {
          console.log("consulting from vuex.watch");
          this.getNextCode(this.prefix).then((numeric) => {
            this.numericCode = numeric;
          });
        }
      }
    );
  },
  methods: {
    async getNextCode(prefix) {
      let { data } = await axios.get(`/next-code/${prefix}`);
      return data.next;
    },
    async prefixChanged(e) {
      this.getNextCode(e).then((numeric) => {
        this.numericCode = numeric;
      });
    },
  },
  watch: {
    /* prefix(newPrefix) {
      console.log('consulting from component.watch');
      if (this.state == 'creating' || this.state == 'updating') {
        this.getNextCode(newPrefix).then(numeric => {
          this.numericCode = numeric;
        });
      }
    }, */
    numericCode(newNumericCode) {
      this.$emit("input", `${this.prefix}${newNumericCode}`);
    },
  },
};
</script>
